import React from 'react';
import logo from './../assests/logo.png';
import user from './../assests/profile.jpeg';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function Header() {
  return (
    <motion.div
      className="header"
      initial={{ opacity: 0, y: '-100%' }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        type: 'spring',
        duration: 0.3,
        stiffness: 120,
        when: 'beforeChildren',
      }}
    >
      <Link to="/">
        <img className="header__logo" src={logo} alt="shoes store" />
      </Link>
      <img className="header__user" src={user} alt="shoes store" />
    </motion.div>
  );
}
